import { initAuth, getAuthLazy } from "~services/auth";

export default {
  crmRoles: state => state.crmRoles,
  operationMenu: state => state.operationMenu,
  dataMenu: state => state.dataMenu,
  freePages: state => state.freePages,
  // 登录状态
  authenticated: state => state.authenticated,
  // 用户信息
  userInfo: state => state.userInfo,

  // 权限
  auth: state => state.authority,
  // 客户权限
  customAuth: state => state.customAuth,
  // 医生客户
  medicalCustomAuth: state => state.medicalCustomAuth,
  // 快捷新增权限
  quickAuth: state => state.quickAuth,
  // 产品线管理
  productManageAuth: state => state.productManageAuth,
  // 拜访权限
  visitAuth: state => state.visitAuth,
  // 合同权限
  contractAuth: state => state.contractAuth,
  // 商机权限
  businessAuth: state => state.businessAuth,
};
